<div class="endpoint">
    <p class="bodyContentBold name">{{(viewModel.onGetEndpoint | async)?.naam}}</p>
    <div class="categorien">
        <ng-container *ngFor="let categorie of (viewModel.onGetEndpoint | async)?.categorieen;">
            <app-input-permission-category [viewModel]="viewModelForCategorie(categorie)"></app-input-permission-category>
        </ng-container>
    </div>
</div>